import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { Cloudinary } from '@cloudinary/angular-5.x';
import { CourseService } from '../../../_services/course.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../_services/global.service';
import { IDeactivateComponent } from '../../../_models/i-deactivate';

@Component({
  selector: 'iq-central-front-end-add-course-module-two',
  templateUrl: './edit-video.component.html',
  styleUrls: ['./edit-video.component.scss'],
})
export class EditVideoComponent
  implements OnInit, OnDestroy, IDeactivateComponent
{
  public_id: any;
  content: any;
  isSubmited = false;
  contentId: string;
  type: any;
  contentName: any;
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.contentForm.dirty || !this.isSubmited) {
      $event.returnValue = true;
    }
  }

  sub: Subscription = new Subscription();
  cloudName = 'cctlf-org';
  unsignedUploadPreset = 'n3zbglni';
  cloudinaryUrl = `https://api.cloudinary.com/v1_1/${this.cloudName}/upload`;
  uploadProgress = 0;
  file: any;
  contentForm: FormGroup;
  filePath: string;
  fileUrl: string;
  lessonId: any;
  courseCode: any;
  go: boolean;
  duration: any;
  name: any;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  contentType: any;
  hasBaseDropZoneOver: boolean;
  uploader: FileUploader;
  title: string;
  response: any;
  fileName: any;
  requiredFileType: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _toastr: ToastrService,
    private cloudinary: Cloudinary,
    private _course: CourseService,
    private _global: GlobalService
  ) {
    this.title = '';
  }
  ngOnInit(): void {
    this.route.data.subscribe((res) => {
      this.content = res['resolvedData'].responseResult;
      this.fileUrl = this.content.filePath;
      this.type = this.content.lessonContent.contentType;
    });

    this.initContentForm();
    this.lessonId = this.route.snapshot.paramMap.get('id');
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.contentId = this.route.snapshot.paramMap.get('contentId');
    this.uploadFileToCloudinary();
  }

  initContentForm() {
    this.contentForm = this.fb.group({
      name: [this.content.lessonContent.name, Validators.required],
      description: [
        this.content.lessonContent.description,
        Validators.required,
      ],
    });
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be saved and you will be taken to your courses',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save',
    }).then((result) => {
      if (result.value) {
        this.updateContent();
      }
    });
  }

  addMoreContent(path) {
    this._global.showSpinner();
    this.updateContent(path);
  }

  updateContent(path?) {
    console.log(this.contentType);

    this.isSubmited = true;
    let contentType = (this.contentType =
      typeof this.contentType === 'undefined' ? this.type : this.contentType);
    if (contentType === 'video' || contentType === 'mp4') {
      const payload = this.contentForm.value;
      payload.contentType = 'video';
      payload.duration = this.duration;
      payload.fileName = this.fileName;
      payload.filePath = this.filePath;
      payload.lessonId = this.lessonId;

      this.sub.add(
        this._course.updateContentVideo(this.contentId, payload).subscribe({
          next: (res) => {
            this._global.hideSpinner();
            if (path) {
              this.router.navigate(['courses/edit-lesson', this.courseCode]);
            } else {
              this._toastr.info('Content updated successfully');
              this.router.navigate(['courses/course-details', this.courseCode]);
            }
          },
        })
      );
    } else {
      this._toastr.warning(
        'Unsupported format please make sure the video is among the listed allowed formats'
      );
    }
  }
  deleteFileFromCloudiary() {
    console.log(this.public_id);
    this.sub.add(
      this._course.deleteFileFromCloudinary(this.public_id).subscribe({
        next: (res) => {},
      })
    );
  }

  canExit(): boolean | Promise<boolean> {
    if (
      confirm(
        'Are you sure you want to leave this page? Any unsaved changes will be lost'
      )
    ) {
      this.deleteFileFromCloudiary();
      return true;
    } else {
      return false;
    }
  }

  uploadFileToCloudinary() {
    const uploaderOptions: FileUploaderOptions = {
      url: this.cloudinaryUrl,
      autoUpload: true,

      // Use xhrTransport in favor of iframeTransport
      isHTML5: true,
      // Calculate progress independently for each uploaded file
      removeAfterUpload: true,
      // XHR request headers
      headers: [
        {
          name: 'X-Requested-With',
          value: 'XMLHttpRequest',
        },
      ],
      allowedMimeType: ['video/mp4'],
    };
    this.uploader = new FileUploader(uploaderOptions);
    this.uploader.onWhenAddingFileFailed = (file, filter) => {
      this.requiredFileType = true;
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
      form.append('upload_preset', this.cloudinary.config().upload_preset);
      let tags = 'content';
      if (this.title) {
        form.append('context', `photo=${this.title}`);
        tags = `content,${this.title}`;
      }
      form.append('folder', 'Video Contents For IQCentral');
      form.append('tags', tags);
      form.append('file', fileItem);
      fileItem.withCredentials = false;

      return { fileItem, form };
    };
    this.uploader.onSuccessItem = (item, response, status, Headers) => {
      if (response) {
        const res = JSON.parse(response);
        this.filePath = res.secure_url;
        this.duration = res.duration;
        this.fileName = res.original_filename;
        this.contentType = res.format;
        this.public_id = res.public_id;
      }
    };
    this.uploader.onProgressItem = (fileItem: any, progress: any) => {
      this.go = true;
      this.fileName = fileItem;
      this.uploadProgress = progress;
    };

    this.uploader.onErrorItem = (status) => {
      this._global.handleNetworkError();
    };
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
